import { useListUsersQuery, type User } from "~/shared/api/user/user.grpc";
import { useSelectedCompany } from "~/shared/store/company/hooks/useSelectedCompany";
import { ConnectProto } from "@racoon/api";
import { useMemo } from "react";

export const useDispatchers = () => {
  const { selectedCompanyId } = useSelectedCompany();

  const { data, isLoading } = useListUsersQuery(
    {
      ownerOrganizationIds: [BigInt(selectedCompanyId ?? 0)],
      roles: [ConnectProto.UserRole.PROVIDER_DISPATCHER],
      statuses: [ConnectProto.UserStatus.ACTIVE],
    },
    {
      skip: !selectedCompanyId,
    },
  );

  const dispatchers = useMemo(() => data?.users ?? [], [data]);

  // Create Map for quick dispatcher lookup by ID using useMemo
  const dispatchersMap = useMemo(() => {
    const map = new Map<number, User>();
    dispatchers.forEach((dispatcher) => {
      map.set(Number(dispatcher.id), dispatcher);
    });
    return map;
  }, [dispatchers]);

  return {
    dispatchers,
    dispatchersMap,
    isLoading,
  };
};
